export const OPERATIONS_LIST_KEY = 'operations_list';

export const loadOperationsList = (): unknown[] => {
  try {
    const raw = localStorage.getItem(OPERATIONS_LIST_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const persistOperationsList = (list: unknown[]): void => {
  localStorage.setItem(OPERATIONS_LIST_KEY, JSON.stringify(list));
};

export const isGlobalAcl = (
  acl: Record<string, unknown> | null | undefined,
): boolean =>
  Object.keys(acl ?? {}).some(
    key => key === 'bn:global' || key.startsWith('bn:global'),
  );

export const orgIdsFromAcl = (
  acl: Record<string, unknown> | null | undefined,
): string[] =>
  Object.keys(acl ?? {})
    .filter(key => key.startsWith('org:'))
    .map(key => key.slice('org:'.length))
    .filter(Boolean);

/** Trocar operação: staff global ou mais de uma org (ou lista já hidratada). */
export const canSwitchOperation = (
  acl: Record<string, unknown> | null | undefined,
  operationsList?: unknown[] | null,
): boolean => {
  if (Array.isArray(operationsList) && operationsList.length > 1) {
    return true;
  }
  if (isGlobalAcl(acl)) {
    return true;
  }
  return orgIdsFromAcl(acl).length > 1;
};
